document.addEventListener("turbolinks:load", function () {
    const guideSection = document.getElementById("changeInGoverningDocumentsSection");
    if (!guideSection) return; // Only run this on the Change in Governing Documents page

    // Map aria-labels to their corresponding section IDs
    const linksToHeaders = {
      "Initial Requirements": "initial_requirements",
      "Hybrid/Electronic Voting Requirement": "electronic_consent_notice",
      "Pre-Ballot Notifications": "pre_ballot_notification",
      "Ballots": "ballots",
      "Results": "results"
    };

    Object.entries(linksToHeaders).forEach(([ariaLabel, targetId]) => {
      const link = document.querySelector(`a[aria-label="${ariaLabel}"]`);
      const target = document.getElementById(targetId);

      if (link && target) {
        link.addEventListener("click", function (e) {
          e.preventDefault();

          const headerOffset = 100; // Adjust for sticky header height
          const elementPosition = target.getBoundingClientRect().top + window.pageYOffset;
          const offsetPosition = elementPosition - headerOffset;

          window.scrollTo({
            top: offsetPosition,
            behavior: "smooth"
          });
        });
      }
    });
  });
